import * as React from 'react'
import Modal from 'LuxKit/Modal/Modal'
import HelpPane from 'components/Common/HelpPane'
import BodyText from 'LuxKit/Typography/BodyText'
import Hr from 'components/Common/Hr'

interface Props {
  className?: string
  heading: string
  isOpen?: boolean
  onClose?: (e: React.MouseEvent<HTMLButtonElement>) => void
  policyDescriptions: Array<string>
  /** Rendered above the descriptions when the restricted policy splits the refund window. */
  timeline?: React.ReactNode
}

function BedbankCancellationPolicyModal(props: Props) {
  const { heading, isOpen, onClose, policyDescriptions, timeline } = props
  return <Modal
    title={heading}
    isOpen={isOpen}
    onClose={onClose}
  >
    {timeline}
    {!!timeline && !!policyDescriptions.length && <Hr size="md" />}
    {policyDescriptions.map(line => <BodyText variant={timeline ? 'medium' : 'large'} as="p" key={line}>{ line }</BodyText>)}
    {!timeline && <HelpPane />}
  </Modal>
}

export default BedbankCancellationPolicyModal
